import { groupBy } from "lodash";
import { DimensionType } from "../../../../types";
import type { DimensionItemDTO, ICalendarItemDTO } from "../../../../api";
import { getFrequencyName, VirtualFrequencyValue } from "../Control/controls/VirtualFrequencyControl";
import { uniq } from "../../../../../../shared";

export function getDisplayOutput(type: DimensionType, selection: unknown[], items: DimensionItemDTO<string | number>[]) {
  switch (type) {
    case DimensionType.CalendarAQM:
    case DimensionType.CalendarAQMW:
    case DimensionType.CalendarAnnual:
    case DimensionType.CalendarWeek:
    case DimensionType.DynamicDateRangeAQM:
    case DimensionType.DynamicDateRangeAQMW:
    case DimensionType.DynamicDateRangeAQMWD:
    case DimensionType.CalendarDay:
    case DimensionType.DynamicDateRangeAnnual:
    case DimensionType.DynamicDateRangeWeek: {
      const groupedItems = groupBy(items, (it) => (it as ICalendarItemDTO<string | number>).frequencyId);
      const groupsAsArray = Object.values(groupedItems);
      return groupsAsArray
        .map((groupItems) => {
          const selectedItems = groupItems.filter((it) => selection.includes(it.id));
          const [firstSelectedItem, ...otherItems] = selectedItems;
          const [lastSelectedItem] = otherItems.reverse();

          return [firstSelectedItem?.name, lastSelectedItem?.name].filter(Boolean).join(" - ");
        })
        .filter(Boolean)
        .join(", ");
    }

    case DimensionType.Frequency:
      return selection.length ? getFrequencyName(selection[0] as VirtualFrequencyValue) : "";
    case DimensionType.BaseIndexAQM:
    case DimensionType.BaseIndexAnnual:
      const byBaseIndexId = (id: unknown) => (it: typeof items[number]) => it.id === id;
      return selection
        .map((id) => items.find(byBaseIndexId(id))?.name)
        .filter(Boolean)
        .join(", ");
    default:
      const byId = (id: unknown) => (it: typeof items[number]) => it.id === id;

      const parentsIds = uniq(items.map((it) => it.parent).filter(Boolean));

      return selection
        .filter((id) => !parentsIds.includes(id as string | number))
        .map((id) => items.find(byId(id))?.name)
        .filter(Boolean)
        .join(", ");
  }
}
